import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PoDSearch from './PoDSearch';
import { makeProductSearchDispatchers } from '../product-search/shared/addItemDispatcher';
import { useFullOrder } from '../product-search/shared/useFullOrder';

interface PoDSearchContainerProps {
  order?: Record<string, any> | null;
  catalogId?: string | null;
  isAddingToProjectNote?: boolean;
}

/**
 * Thin wrapper supplying PoDSearch with the redux wiring it previously got
 * from ProductSearch, for rendering outside the white Box in the Add Product
 * popup (mirrors SuggestionContainer for Connected+).
 */
const PoDSearchContainer: React.FC<PoDSearchContainerProps> = ({
  order,
  catalogId,
  isAddingToProjectNote = false,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state: any) => state.display.loading.add_item);
  const full_order = useFullOrder(order);

  const { addItem, deleteItem } = useMemo(
    () => makeProductSearchDispatchers({
      dispatch,
      order: order as { order_id?: string; order_type?: string } | null,
      catalogId,
      isAddingToProjectNote,
    }),
    [dispatch, order, catalogId, isAddingToProjectNote]
  );

  const onAddItem = async (item: Record<string, unknown>) => addItem({
    parentId: (item.ext_product_id || item.parent_id) as string,
    copiedFrom: item.copied_from as string,
    currencyId: item.currency_id as string,
    sku: item.item_sku as string,
    divisionId: item.division_id as string,
    isSageConnect: 'sage_connect' === item.copied_from,
  });

  return (
    <PoDSearch
      order={order}
      full_order={full_order}
      loading={loading || []}
      onAddItem={onAddItem}
      onDeleteItem={deleteItem}
      isProductsPage={false}
    />
  );
};

export default PoDSearchContainer;
